import {LABELS} from '@github-ui/item-picker-base/constants/labels'
import {SharedPicker} from '@github-ui/item-picker-base/SharedPicker'
import {MilestoneIcon} from '@primer/octicons-react'
import {forwardRef} from 'react'
import type {ItemPickerMilestoneProps} from './ItemPickerMilestone'

type DefaultMilestonePickerAnchorProps = Pick<ItemPickerMilestoneProps, 'activeMilestone' | 'readonly' | 'nested'> & {
  anchorProps?: React.HTMLAttributes<HTMLElement> | undefined
}

export const DefaultMilestonePickerAnchor = forwardRef<HTMLButtonElement, DefaultMilestonePickerAnchorProps>(
  ({activeMilestone, readonly, nested, anchorProps}, ref) => {
    return (
      <SharedPicker
        anchorText={LABELS.noMilestones}
        sharedPickerMainValue={activeMilestone?.title}
        anchorProps={readonly ? undefined : anchorProps}
        ariaLabel={LABELS.selectMilestones}
        readonly={readonly}
        nested={nested}
        leadingIcon={MilestoneIcon}
        hotKey={undefined}
        ref={ref}
      />
    )
  },
)

DefaultMilestonePickerAnchor.displayName = 'DefaultMilestonePickerAnchor'
